import React from "react";
import "./header.css";
import imgAi from "../../assets/ai.png";
import imgReq from "../../assets/people.png";

const Header = () => {
  return (
    <div className="gpt3__header" id="home">
      <div className="gpt3__header-row">
        <div className="gpt3__header-left">
          <h1 className="gpt3__header-title">
            Let’s Build Something amazing with GPT-3 OpenAI
          </h1>
          <p className="gpt3__header-par">
            Yet bed any for traveling assistance indulgence unpleasing. Not
            thoughts all exercise blessing. Indulgence way everything joy
            alteration boisterous the attachment. Party we years to order allow
            asked of.
          </p>
          <form className="gpt3__header-form" action="" method="post">
            <input
              type="email"
              placeholder="Your Email Address"
              name=""
              id=""
            />
            <input type="submit" value="Get Started" />
          </form>
          <div className="gpt3__header-accessRequested">
            <img src={imgReq} alt="People requested access" />
            <p>1,600 people requested access a visit in last 24 hours</p>
          </div>
        </div>
        <div className="gpt3__header-right">
          <img src={imgAi} alt="Logo of GPT3" />
        </div>
      </div>
    </div>
  );
};

export default Header;
